import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import {Helmet} from "react-helmet";




const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<>
<Helmet>
	<title>Camp Leslie: Boynton</title>
	<meta name="description" content="A place for camp" />	
	</Helmet>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<App />
		</ThemeProvider>


	</>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
